export default "__VITE_ASSET__DGpv9sRT__"